// 联系我们
<template>
    <div class="contact">
        <div class="one1">
            <div class="aboutContent">
                <div class="title">联系我们</div>
                <div class="explain">CONTACT US</div>
            </div>
            <div class="contactBottom">
                <div class="contactContent">
                    <baidu-map class="bm-view" :center="center" :zoom="zoom" @ready="handler" :scroll-wheel-zoom="true">
                        <bm-marker :position="{lng: 121.212665, lat: 31.62721}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE"></bm-marker>
                    </baidu-map>
                </div>
                <div class="contacts">
                    <div class="item">
                        <div class="name">德木客服：</div>
                        <div class="content">
                            <div class="text">龚静怡17772236177</div>
                            <div class="text">唐新宇17712686596</div>
                            <div class="text">王添逸13862376246</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="name">技术主管：</div>
                        <div class="content">
                            <div class="text">姚凯13636535807（对系统功能有新的需求或建议联系此号码）</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    props: {
        
    },
    data(){
        return{
            center: {lng: 0, lat: 0},
            zoom:3
        }
    },
    methods:{
        handler({BMap, map}){
            this.center.lng = 121.212665
            this.center.lat = 31.62721
            this.zoom = 15
        }
    }
}
</script>

<style scoped>
    .contact{background: #EAF0F5;}
    .one1{width: 100%;padding: 35rem 0 5rem 0;background: url(https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/home_back36.jpg) no-repeat top center;background-size:100% auto;display: flex;flex-direction: column;justify-content: center;position: relative;}
    
    .aboutContent{position: absolute;left: 50%;top: 20rem;transform: translateX(-50%) translateY(-50%);}
    .aboutContent .title{font-size: 3rem;color: #fff;text-align: center;}
    .aboutContent .explain{text-align: center;margin-top: 2rem;font-size: 1.4rem;color: #fff;}

    .contactBottom{padding: 0 1rem;}
    .contactContent{max-width: 110rem;min-height: 60rem; padding: .5em;margin: 0 auto;background: white;border-radius: 20px;border: 6px solid #3A6DF3;box-shadow: 3px 3px 15px rgb(51 51 51 / 50%);}
    .contacts{max-width: 110rem;margin: 2rem auto 0 auto;font-size: 1.4rem;}
    .contacts .item{display: flex;margin: 1rem 0;color: #333;font-weight: 600;}
    .contacts .item:last-child{margin-bottom: 0;}

    .bm-view{width: 100%;height: 60rem;}
    
</style>
